import styles from "./ProductCell.module.less";
import { image as imageUtil, utils, productUtil } from "@/utils";
import { useNavigate } from "react-router-dom";
import { Image } from 'antd-mobile'
import React, { useEffect, useState } from "react";

const { imgFormatter } = imageUtil;
const { to } = utils;

interface ProductCellProps {
  item: any;
  index: number;
  cellWidth: string;
}

interface Thumb {
  url: string;
  backupUrl?: string;
}

/* 
 * 货品详情
 */
const ProductCell: React.FC<ProductCellProps> = (props) => {
  const navigate = useNavigate();

  const { item, index, cellWidth } = props;
  const [lastImgUrl, setLastImgUrl] = useState<string>("");
  const [thumbObj, setThumbObj] = useState<Thumb>({
    url: "",
  });

  // 跳转详情页
  const handleGoDetail = (productId: string) => {
    navigate(`/product-1688/detail/${productId}`);
  };

  // 初始化缩略图
  async function initThumb() {
    const { imageList } = item.cloudProduct;
    const imgUrl = (imageList && imageList[0]) || '';

    if (imgUrl === lastImgUrl) return;

    const [err, res] = await to(imgFormatter(imgUrl, 260));

    setLastImgUrl(imgUrl);
    setThumbObj({ url: err ? imgUrl : res });
  }

  useEffect(() => {
    initThumb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item]);

  /* 
  * 货品详情
  */
  return (
    <div className={styles["product-item"]} key={index} onClick={() => handleGoDetail(item.cloudProduct.productId)}>
      <div className={styles["img-wrap"]} data-index={cellWidth} style={{ height: cellWidth }}>
        <Image
          src={thumbObj.url}
          fit="cover"
          height={cellWidth}
          className={styles["preview-img"]}
          lazy={true}
        />
      </div>
      <div className={styles["text-wrap"]}>
        <h3 className={styles["title"]}>
          <span className={productUtil.getRecommendClass(item.cloudProduct)}>
            {productUtil.getRecommendTag(item.cloudProduct)}
          </span>
          {item.cloudProduct.productName || ""}
          {item.cloudProduct.productNo ? `(${item.cloudProduct.productNo})` : null}
        </h3>
      </div>
    </div>
  );
};

export default ProductCell;
